"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _navigationHelpers = require("../../helpers/navigationHelpers");

var _NavigationFlyout = _interopRequireDefault(require("../components/NavigationFlyout/NavigationFlyout"));

var _Link = _interopRequireDefault(require("../../../shared/components/Link/Link"));

var _createUniqueId = _interopRequireDefault(require("../../../shared/helpers/createUniqueId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavigationMain = function NavigationMainComponent(_ref) {
  var categories = _ref.categories;
  var leftAlignNav = categories.length < 4;
  var navCategories = (0, _classnames["default"])({
    'navigation-main__categories': true,
    'navigation-main__categories--left-align': leftAlignNav
  });
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: "navigation-main",
    role: "navigation",
    "aria-label": "Main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: navCategories
  }, categories.map(function (category) {
    var navCategory = (0, _classnames["default"])({
      'navigation-main__category': true,
      'navigation-main__category--left-align': leftAlignNav,
      'navigation-main__category--active': (0, _navigationHelpers.isActiveNavItem)(category.url),
      'navigation-main__category--flyout--active': (0, _navigationHelpers.isActiveNavFlyout)(category)
    });
    var flyoutId = (0, _createUniqueId["default"])('navigation_flyout_', category.id);

    if (category.subGroups && category.subGroups.length) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: category.id,
        className: "".concat(navCategory, " navigation-main__category--flyout")
      }, /*#__PURE__*/_react["default"].createElement(_NavigationFlyout["default"], {
        id: flyoutId,
        styleFlag: "nav-flyout",
        navItem: category
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "navigation-main__category-accent"
      }));
    }

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: category.id,
      className: navCategory
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      className: "navigation-main__link",
      href: category.url,
      external: category.isExternal
    }, category.name), /*#__PURE__*/_react["default"].createElement("span", {
      className: "navigation-main__category-accent"
    }));
  }))));
};

NavigationMain.propTypes = {
  categories: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = NavigationMain;
exports["default"] = _default;